// @flow
import { TypesContactsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    typeContact: {},
    listaTypesContacts: [],
    loading: false,
    error: false,
    formSubmited: false
};

type TypesContactsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { typeContact?: {} | null, listaTypesContacts?: [] | null, loading?: boolean, +value ?: boolean };

const TypesContacts = (state: State = INIT_STATE, action: TypesContactsAction): any => {
    // console.log(action);
    switch (action.type) {
        case TypesContactsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TypesContactsActionTypes.GET_TYPES_CONTACTS: {
                    return {
                        ...state,
                        typeContact: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case TypesContactsActionTypes.LIST_TYPES_CONTACTS: {
                    return {
                        ...state,
                        listaTypesContacts: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case TypesContactsActionTypes.ADD_TYPES_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TypesContactsActionTypes.UPDATE_TYPES_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TypesContactsActionTypes.DELETE_TYPES_CONTACTS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TypesContactsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TypesContactsActionTypes.GET_TYPES_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        typeContact: {},
                        loading: false,
                    };
                }
                case TypesContactsActionTypes.LIST_TYPES_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaTypesContacts: [],
                        loading: false,
                    };
                }
                case TypesContactsActionTypes.ADD_TYPES_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TypesContactsActionTypes.UPDATE_TYPES_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case TypesContactsActionTypes.DELETE_TYPES_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TypesContactsActionTypes.GET_TYPES_CONTACTS:
            return { ...state, error: false, loading: true };
        case TypesContactsActionTypes.LIST_TYPES_CONTACTS:
            return { ...state, error: false, loading: true };
        case TypesContactsActionTypes.ADD_TYPES_CONTACTS:
            return { ...state, error: false, loading: true };
        case TypesContactsActionTypes.UPDATE_TYPES_CONTACTS:
            return { ...state, error: false, loading: true };
        case TypesContactsActionTypes.DELETE_TYPES_CONTACTS:
            return { ...state, error: false, loading: true };
        case TypesContactsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                typeContact: {},
                listaTypesContacts: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default TypesContacts;
